import _ from 'lodash';
import PipelineItem from './ClickablePipelineItem';
import PipelineArrow, { PipelineArrowWrapper } from './PipelineArrow';
import { Tooltip } from '@material-ui/core';
import history from 'common/RouterHistory';
import { Flex } from 'components/base/layout-components';
import QueryString from 'query-string';
import React from 'react';
import styled from 'styled-components';
import { getRedirectParamsByMetric } from 'common/constants/metrics';
import { TRACKING } from 'common/constants/constants';
import { useSelector } from 'react-redux';
import * as TrackingService from 'common/services/tracking.service';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import { getWhichMetricShouldShowGitStreamCTA } from './ClickableDeploymentPipeline.service';
import GitStreamCTABadgeWithTooltip from 'components/GitStreamCTABadgeWithTooltip';

const PipelineItemWithArrow = styled(Flex)`
  width: 100%;
`;

const PipelineWrapper = styled(Flex)`
  ${({ isV2 }) => (isV2 ? '' : 'padding: 0 1rem;')};
  width: 100%;
  & ${PipelineArrowWrapper} {
    margin: ${({ isV2 }) => (isV2 ? '0rem 1.2rem' : '0rem 1rem')};
  }
`;

const ClickableDeploymentPipeline = ({
  configurations = [],
  dates,
  enableDescription = true,
  isV2 = false,
  isShowGitStreamCTA,
  dataCyPrefix = ''
}) => {
  const selectedTeam = useSelector(selectedTeamSelector);
  const onPipelineItemClick = config => {
    const { from, to } = dates;
    const { metricName } = config;
    const point = {
      category: { after: from, before: to }
    };
    const getRedirectParams = getRedirectParamsByMetric()({ metricName });
    const redirectParams = getRedirectParams(point);

    const search = QueryString.parse(window.location.search, {
      ignoreQueryPrefix: true
    });
    const baseParams = {
      ...(selectedTeam ? { teams: selectedTeam.id } : {}),
      iteration_id: search.iteration_id
    };

    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.DASHBOARD,
      click_type: TRACKING.CLICK.DRILLDOWN,
      element: _.get(config, 'title', TRACKING.CLICK.CYCLE_TIME)
    });

    history.push({
      pathname: redirectParams.path,
      search: QueryString.stringify({
        ...baseParams,
        ...redirectParams.qs
      }),
      state: _.get(redirectParams, 'state', {})
    });
  };

  const whichMetricShouldShowGitStreamCTA =
    getWhichMetricShouldShowGitStreamCTA(configurations);

  return configurations.length ? (
    <PipelineWrapper isV2={isV2}>
      {configurations.map((config, idx) => {
        const showGitStreamCTA =
          isShowGitStreamCTA &&
          config.title === whichMetricShouldShowGitStreamCTA;
        const gitStreamTooltipTitle = `${_.capitalize(config.title)} Time`;
        const gitStreamBadgeContent = `Improve ${_.capitalize(
          config.title
        )} Time`;

        return (
          <Flex
            direction='column'
            width='24%'
            key={config.title}
            data-testid='ClickableDeploymentPipeline'
          >
            <Tooltip placement='top-start' title={`View activity`}>
              <PipelineItemWithArrow>
                <PipelineItem
                  key={config.title}
                  config={config}
                  onClick={onPipelineItemClick}
                  enableDescription={enableDescription}
                  isV2={isV2}
                  dataCyPrefix={dataCyPrefix}
                />
                <PipelineArrow isV2={isV2} />
              </PipelineItemWithArrow>
            </Tooltip>
            {showGitStreamCTA && (
              <GitStreamCTABadgeWithTooltip
                title={gitStreamTooltipTitle}
                gitStreamBadgeContent={gitStreamBadgeContent}
              />
            )}
          </Flex>
        );
      })}
    </PipelineWrapper>
  ) : null;
};

export default ClickableDeploymentPipeline;
